<template>
  <div class="has-text-centered">
    <h1 class="title is-3 has-text-centered mt-3" style="font-size: 70px">
      403
    </h1>
    <img style="height: 400px" :src="logo" alt="Goldmedia" />
    <h5 class="subtitle is-3 has-text-centered mt-2">Verboten</h5>
  </div>
</template>

<script>
import logo from '../assets/404.jpeg';

export default {
  metaInfo: {
    title: '403',
  },
  data() {
    return {
      logo,
    };
  },
};
</script>

<style>
</style>
